// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3xqz8","title":"BackImages_title__3OYye","images":"BackImages_images__1YxTs"};